module.exports = __webpack_public_path__ + "img/train.e2fc2878.svg";